import React, { useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { setIsOnScript } from 'state/script.state';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';

interface ScriptStepCopyProps {
  isCurrentStep: boolean;
  messageText: string;
  stepName: string;
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(1),
  },
  button: {
    fontWeight: 'bold',
    lineHeight: '1.5',
  },
}));

const ScriptStepCopy = ({ isCurrentStep, messageText, stepName }: ScriptStepCopyProps) => {
  const dispatch = useDispatch();
  const styles = useStyles();

  const [isCopied, setIsCopied] = useState(false);

  const onClick = () => {
    // there is a listener for this event that places the text in the message box
    const copyEvent = new CustomEvent('scriptCopy', {
      detail: {
        message: messageText,
      },
    });

    document.dispatchEvent(copyEvent);

    // turn the on-script flag on if we're copying the current step, otherwise turn it off
    dispatch(
      setIsOnScript({
        isOnScript: isCurrentStep,
        onScriptStep: isCurrentStep ? stepName : null,
      })
    );

    // temporarily show the "Copied!" message
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <div className={styles.container}>
      <Button color="secondary" className={styles.button} onClick={() => onClick()}>
        <ChevronLeftRoundedIcon fontSize="small" />
        {isCopied ? 'Copied!' : 'Copy'}
      </Button>
    </div>
  );
};

export default ScriptStepCopy;
